export const maxRepeatedCharsRegexp: RegExp = /^(?!.*(.)\1{3,}).*$/;
